module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('skirental.pick-equipment')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, _vm._l((_vm.params.options), function(option, key) {
    return _c('div', [(option) ? _c('button', {
      staticClass: "small white underlined",
      on: {
        "click": function($event) {
          return _vm.clicked(key)
        }
      }
    }, [_vm._v(_vm._s(option.name))]) : _vm._e()])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ad815c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiRentalCategories.vue
// module id = 893
// module chunks = 0